import { render, staticRenderFns } from "./PromoBlock.vue?vue&type=template&id=3f0ac781"
import script from "./PromoBlock.vue?vue&type=script&lang=js"
export * from "./PromoBlock.vue?vue&type=script&lang=js"
import style0 from "./PromoBlock.vue?vue&type=style&index=0&id=3f0ac781&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports